import React, { useState, useEffect } from "react";
import axios from "axios";
import '@fortawesome/fontawesome-free/css/all.min.css';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
    
const EditableCards = ({ customerData, CompanyId, userid, animal, bookdate }) => {
  const [searchKeyword, setSearchKeyword] = useState("");
  const [filteredCustomerData, setFilteredCustomerData] = useState(customerData);
  const [inputValues, setInputValues] = useState({});
  const [loadingStates, setLoadingStates] = useState({});

  const apireq05042024 = process.env.REACT_APP_SERVER_API_URL+"/";
  const MySwal = withReactContent(Swal);
  
  useEffect(() => {
    setFilteredCustomerData(
      customerData.filter((customer) =>
        customer.customer_name.toLowerCase().includes(searchKeyword.toLowerCase())
      )
    );
  }, [searchKeyword, customerData]);

  const handleInputChange = (customerId, field, value) => {
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setInputValues((prev) => ({
        ...prev,
        [customerId]: {
          ...prev[customerId],
          [field]: value,
        },
      }));
    }
  };
  

  const ShortEdit = async (event, customer) => {
    event.preventDefault();

    const customerId = customer.customer_mp_id;

    // Set the loading state to true for this customer
    setLoadingStates((prev) => ({ ...prev, [customerId]: true }));  

    const updatedCowQty = inputValues[customer.customer_mp_id]?.cowqty || customer.cowqty;
    const updatedBuffQty = inputValues[customer.customer_mp_id]?.buffqty || customer.buffqty;

    const payload = {
      CompanyId,
      userid,
      tran_date: new Date().toISOString().split("T")[0],
      // tran_date: bookdate,
      transactionid: customer.transaction_id,
      customer_mp_id: customer.customer_mp_id,
      cowqty: updatedCowQty,
      buffqty: updatedBuffQty,
      cowrate: customer.cowrate,
      buffrate: customer.buffrate,
      centerid: customer.centerid,
      routename: customer.routename,
      customer_centerwiseid: customer.customer_centerwiseid,
      customer_name: customer.customer_name,
      customer_place: customer.customer_place,
      customer_mobile: customer.customer_mobile,
    };
    // console.log(payload);return;
    try {
      const response = await axios.post(
        payload.transactionid !== undefined
          ? apireq05042024 + "DailyDeliverySheet/ShortEdit"
          : apireq05042024 + "DailyDeliverySheet/insert",
        payload
      );

      if (response.status === 200) {
        if (response.data === "Successfully Updated" || response.data.message === "Successfully inserted") {
          MySwal.fire({
            html: <b>{response.data === "Successfully Updated" ? "Record updated successfully" : "Record inserted successfully"}</b>,
            icon: "success",
          });
          setFilteredCustomerData((prev) =>
            prev.map((item) =>
              item.customer_mp_id === customer.customer_mp_id
                ? {
                    ...item,
                    cowqty: Number(updatedCowQty) > 0.0001 ? updatedCowQty : item.cowqty,
                    buffqty: Number(updatedBuffQty) > 0.0001 ? updatedBuffQty : item.buffqty,
                    transaction_id: response.data.new_transaction_id || item.transaction_id,
                  }
                : item
            )
          );          
          setInputValues((prev) => ({ //Why setInputValues values used here? Explain the code.
            ...prev,
            [customer.customer_mp_id]: {},
          }));
        } else if (response.data.error) {
          MySwal.fire({
            html: <b>{response.data.error}</b>,
            icon: "warning",
          });
        }
      }
    } catch (error) {
      console.error("Error updating data:", error);
    } finally {
      // Reset the loading state for this customer
      setLoadingStates((prev) => ({ ...prev, [customerId]: false }));
    }
  };

  return (
    <div>
      <div className="row mb-3">
        <div className="col-md-12">
          <input
            type="text"
            className="form-control"
            placeholder="Search by customer name..."
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
          />
        </div>
      </div>

      <div className="row">
        {filteredCustomerData.map((customer) => (
          <div className="col-md-4 mb-3" key={customer.customer_mp_id}>
            <div className="card h-100" style={{ boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)" }}>
              <div className="card-body">
                <h5 className="card-title">{customer.customer_name}  
                <i className="fa-solid fa-phone" style={{ marginLeft: "10px", marginRight: "5px", color: "#007bff", cursor: "pointer" }}></i>
                - <a href={`tel:${customer.customer_mobile}`} >{customer.customer_mobile}</a></h5>
               
                <div className="form-group">
                  {animal === "cow" && (
                    <div className="row align-items-center">
                      <div className="col-6">
                        <label htmlFor={`label-cowqty-${customer.customer_mp_id}`}>Cow Qty</label>
                        <input
                          type="text"
                          className="form-control"
                          value={
                            inputValues[customer.customer_mp_id]?.cowqty !== undefined
                              ? inputValues[customer.customer_mp_id].cowqty
                              : customer.cowqty || ""
                          }
                          onChange={(e) =>
                            handleInputChange(customer.customer_mp_id, "cowqty", e.target.value)
                          }
                        />
                      </div>
                      <div className="col-6 text-right">
                        <button
                          className="btn btn-primary mt-4"
                          onClick={(e) => ShortEdit(e, customer)}
                          disabled={loadingStates[customer.customer_mp_id] || false}
                        >
                          {loadingStates[customer.customer_mp_id] ? "Saving..." : "Save"}
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                <div className="form-group">
                  {animal === "buff" && (
                    <div className="row align-items-center">
                      <div className="col-6">
                        <label htmlFor={`label-buffqty-${customer.customer_mp_id}`}>Buff Qty</label>
                        <input
                          type="text"
                          className="form-control"
                          value={
                            inputValues[customer.customer_mp_id]?.buffqty !== undefined
                              ? inputValues[customer.customer_mp_id].buffqty
                              : customer.buffqty || ""
                          }
                          onChange={(e) =>
                            handleInputChange(customer.customer_mp_id, "buffqty", e.target.value)
                          }
                        />
                      </div>
                      <div className="col-6 text-right">
                        <button
                          className="btn btn-primary mt-4"
                          onClick={(e) => ShortEdit(e, customer)}
                          disabled={loadingStates[customer.customer_mp_id] || false}
                        >
                          {loadingStates[customer.customer_mp_id] ? "Saving..." : "Save"}
                        </button>
                      </div>
                    </div>
                  )}
                </div>


              </div>
              
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EditableCards;
